import CancelSignalScheduleRoot from '../../components/pages/CancelSignalSchedule';
import { FullHeightOnly } from '../../components/shared/Grid';
import TemplateCenter from '../../layout/TemplateCenter';

const CancelSignalSchedule = () => {
  return (
    <TemplateCenter>
      <FullHeightOnly>
        <CancelSignalScheduleRoot />
      </FullHeightOnly>
    </TemplateCenter>
  );
};

export default CancelSignalSchedule;
